import * as React from "react";
import { AccountWithoutPassword } from "../../../../../server/models/account";
import { reducer, initState } from "../../../reducers/activity/member";
import { Loading } from "../../../../../react-components/lu-component/src/index";
import { ConfirmBox } from "../../../components/parts/confirm-box";
import { SwitchConfirm, SwitchConfirmEvent } from "../../../components/parts/switch-confirm";
import { useNavigate, useParams } from "react-router-dom";
import { ActivityMemberPage } from "../../../components/pages/activity/member";
import { get, makeError, put } from "../../../lib/request";
import { GetActivityMemberResponse } from "../../../../../server/types/request/activity";
import { endpoint } from "../../../../../server/router/endpoint";

export const ActivityMemberContainer = (loginAccount: AccountWithoutPassword) => {
	const [state, dispatch] = React.useReducer(reducer, initState);
	const navigate = useNavigate();
	const { activityId } = useParams<{ activityId: string }>();
	const { loading, info, ...activityMemberPageProps } = state;
	React.useEffect(() => {
		get<GetActivityMemberResponse>(`${endpoint.activityMember}/${activityId}`)
			.then((response) => {
				dispatch({ type: "loadActivity", payload: response.data });
			})
			.catch((error) => {
				dispatch({ type: "changeMessageInfo", payload: makeError(error) });
			});
	}, [activityId]);
	const events = React.useMemo<SwitchConfirmEvent[]>(() => {
		return [
			{
				label: "アクティビティ一覧に戻る",
				variant: "outline-secondary",
				func: () => navigate(`/activity`),
			},
		];
	}, [navigate]);
	const onSubmit = React.useCallback(() => {
		dispatch({ type: "changeLoading", payload: true });
		put<GetActivityMemberResponse>(`${endpoint.activityMember}/${activityId}`, {
			accountIds: activityMemberPageProps.activityMembers,
		})
			.then(() => {
				dispatch({ type: "updateMembers", payload: undefined });
			})
			.catch((error) => {
				dispatch({ type: "changeMessageInfo", payload: makeError(error) });
			});
	}, [activityId, activityMemberPageProps.activityMembers]);
	const onChange = React.useCallback((value: string[]) => dispatch({ type: "changeMembers", payload: value }), []);
	return (
		<>
			<Loading loading={loading} text={"processing..."} />
			{!info.isSuccess && <ConfirmBox info={info} />}
			<SwitchConfirm
				show={info.isSuccess && !!info.message}
				title={"アクティビティ登録者の更新"}
				body={info.message}
				events={events}
			/>
			{activityMemberPageProps.activity && (
				<ActivityMemberPage
					{...activityMemberPageProps}
					onChange={onChange}
					onSubmit={onSubmit}
					loginAccount={loginAccount}
				/>
			)}
		</>
	);
};
